import { styled } from 'styled-components';

import { memoGeneric } from '@/js/libs/memo/index.ts';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Marker = styled.span<{ $informative?: boolean; $positive?: boolean; $warning?: boolean; $negative?: boolean }>`
  font-size: 0.8em;
  vertical-align: middle;
  white-space: nowrap;
  color: ${({ theme, $informative, $positive, $warning, $negative }) => {
    if ($informative) return theme.colors.link100;
    if ($positive) return theme.colors.positive100;
    if ($warning) return theme.colors.warning100;
    if ($negative) return theme.colors.critical100;
    return theme.colors.black_1;
  }};
`;

interface OptionMarkedLabelPropsBase<T> {
  marker: string;
  option: {
    label: string;
    value: T;
    active?: boolean;
  };
}

type OptionMarkedLabelProps<T> = OptionMarkedLabelPropsBase<T> &
  (
    | { informative: boolean; positive?: never; warning?: never; negative?: never }
    | { informative?: never; positive: boolean; warning?: never; negative?: never }
    | { informative?: never; positive?: never; warning: boolean; negative?: never }
    | { informative?: never; positive?: never; warning?: never; negative: boolean }
  );

export const OptionMarkedLabel = memoGeneric(function OptionMarkedLabel<T>({
  option,
  informative,
  positive,
  warning,
  negative,
  marker,
}: OptionMarkedLabelProps<T>) {
  if ((negative ? !option?.active : option?.active) || informative || positive || warning) {
    return (
      <Wrapper>
        <span>{option?.label}</span>
        <Marker $informative={informative} $positive={positive} $warning={warning} $negative={negative}>
          {marker}
        </Marker>
      </Wrapper>
    );
  }
  return option?.label;
});
